import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { bl_fi_mst_entity_ext_RowClass, CompanyService, CustomerService, PricingSchemeLinkService, SupplierService, TaxCodeCfgService } from "blg-akaun-ts-lib";
import { PricingSchemeModel } from "../../models/pricing-scheme.model";
import { PermissionStates } from "../../modules/permission/permission-controller/root";
import { SessionSelectors } from "../../modules/session/session-controller/selectors";
import { SessionStates } from "../../modules/session/session-controller/states";
import { AppConfig } from "../../visa";
import { combineLatest, of, ReplaySubject } from "rxjs";
import { SubSink } from "subsink2";
import { take } from 'rxjs/operators'

interface PricingScheme {
  fiItemHdrGuid: string;
  priceName: string;
  priceAmount: number;
}

interface CompanyTax {
  taxCode: string;
  taxRate: number;
  taxType: string;
}

@Component({
  selector: "app-pricing-scheme-access-v2",
  templateUrl: "./pricing-scheme-v2.component.html",
  styleUrls: ["./pricing-scheme-v2.component.css"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class PricingSchemeV2Component implements OnInit, OnDestroy {
  @Input() postingStatus: string;
  @Input() currentPrice: number;
  @Input() editMode: boolean;
  @Input() unitPriceType: string;
  // @Input() fiItem?: FinancialItemContainerModel;
  @Input() companyGuid?: string;
  @Output() selectedPricingScheme = new EventEmitter<any>();

  defaultPriceScheme = new FormControl();

  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;
  @Input() customerGuid;
  @Input() supplierGuid;
  @Input () branchGuid;
  entityBranch: any;

  pricingSchemefilterControl = new FormControl();
  pricingScheme: FormControl = new FormControl();
  filteredPricingScheme$: ReplaySubject<PricingScheme[]> = new ReplaySubject<
    PricingScheme[]
  >(1);
  customerTax:bl_fi_mst_entity_ext_RowClass;
  supplierTax:bl_fi_mst_entity_ext_RowClass;
  fiItem:any; 
  
  private subs = new SubSink();
  dtoObject;
  authorization: string;
  appletGuid: string;
  tenantGuid: string;
  rank: string;
  apiVisa = AppConfig.apiVisa;
  pricingSchemeHdrGuids: any[] = [];
  filteredPricingSchemes: any[] = [];
  fiItemHdrGuid: any;
  pricingSchemeAccessKey: any;
  defaultPricingSchemeHdr: any;
  pricingSchemeValue: any;
  selectFieldDisabled: boolean = true;
  entityBranchHdr: any;

  constructor(
    private pricingSchemeLinkService: PricingSchemeLinkService,
    protected readonly sessionStore: Store<SessionStates>,
    protected readonly pricingSchemeAccessStore: Store<PermissionStates>,
    private customerService: CustomerService,
    private supplierService: SupplierService,
    private companyService: CompanyService,
    private taxConfigService: TaxCodeCfgService,
  ) {}

  ngOnInit() {
    if (this.postingStatus === 'FINAL') {
      this.selectFieldDisabled = true;
    }
  
    this.subs.sink = this.sessionStore
      .select(SessionSelectors.selectRolePricingSchemeLink)
      .pipe(take(1))
      .subscribe((data) => {
        data?.forEach((pricingSchemeLink) => {
          this.pricingSchemeHdrGuids.push(
            pricingSchemeLink.bl_applet_role_pricing_scheme_link
              .pricing_scheme_guid
          );
        });
      });
  
    const entityBranch$ = this.ColumnViewSelectors?.selectEntityBranch 
      ? this.viewModelStore.select(this.ColumnViewSelectors.selectEntityBranch)
      : of(null); 
  
    this.subs.sink = combineLatest([
      this.viewModelStore.select(this.ColumnViewSelectors.selectDefaultPricingSchemeHdr),
      this.viewModelStore.select(this.ColumnViewSelectors.selectFIItemHdrGuid),
      this.viewModelStore.select(this.ColumnViewSelectors.selectPricingSchemeAccessKey),
      this.viewModelStore.select(this.ColumnViewSelectors.selectPricingScheme),
      this.viewModelStore.select(this.ColumnViewSelectors.selectFIItem),
      entityBranch$,
    ])
    .subscribe(
      ([
        defaultPricingSchemeHdr,
        fiItemHdrGuid,
        pricingSchemeAccessKey,
        pricingScheme,
        fiItem,
        entityBranch
      ]) => {
        this.defaultPricingSchemeHdr = defaultPricingSchemeHdr;
        this.fiItemHdrGuid = fiItemHdrGuid;
        this.pricingSchemeAccessKey = pricingSchemeAccessKey;
        this.pricingSchemeValue = pricingScheme;
        this.fiItem = fiItem;
        this.entityBranch = entityBranch;
  
        this.dtoObject = {
          item_hdr_guid: this.fiItemHdrGuid,
          item_line_guid: "",
          // pricing_scheme_hdr_guids: this.pricingSchemeHdrGuids,
        };
        this.authorization = localStorage.getItem("authToken");
        this.appletGuid = sessionStorage.getItem("appletGuid");
  
        this.subs.sink = this.sessionStore
          .select(SessionSelectors.selectAppletLoginSubjectLink)
          .subscribe((data) => {
            this.tenantGuid = data.tenant_guid.toString();
          });
  
        this.subs.sink = this.sessionStore
          .select(SessionSelectors.selectUserRank)
          .subscribe((data) => {
            this.rank = data;
          });
  
        if (this.unitPriceType.toUpperCase() === "SALES") {
          this.getSalesSidePricingScheme();
        } else if (this.unitPriceType.toUpperCase() === "PURCHASE") {
          this.getPurchaseSidePricingScheme();
        }
      }
    );
  }  

  getSalesSidePricingScheme() {
    let companyTax: CompanyTax;

    this.pricingSchemeLinkService
      .getSalesSidePricingSchemes(this.dtoObject, this.appletGuid, this.tenantGuid, this.rank, this.apiVisa)
      .subscribe((data) => {
        let salesSidePricingSchemeList: PricingSchemeModel[] = [];

        const processPricingScheme = (pricingSchemeData) => {
          console.log("1. entityBranchHdr", this.entityBranchHdr);
          console.log("2. customerTax", this.customerTax);
          console.log("3. pricingSchemeData", pricingSchemeData);
          console.log("4. fiItem", this.fiItem);
          console.log("5. companyTax", companyTax);
          let pricingSchemeModel = new PricingSchemeModel();

          if (this.entityBranchHdr && this.entityBranchHdr?.output_tax_code !== undefined && this.entityBranchHdr?.output_tax_code !== null && this.entityBranchHdr?.output_tax_code !== "") {
            pricingSchemeModel.taxCode = this.entityBranchHdr?.output_tax_code
            pricingSchemeModel.taxRate = this.entityBranchHdr?.output_tax_rate
            pricingSchemeModel.taxType = this.entityBranchHdr?.output_tax_type
          } else if (this.customerTax && this.customerTax !== undefined && this.customerTax !== null && this.customerTax?.value_json && this.customerTax?.value_json['tax_code'] !== "") {
            pricingSchemeModel.taxCode = this.customerTax.value_json['tax_code'];
            pricingSchemeModel.taxRate = +this.customerTax.value_json['tax_rate'];
            pricingSchemeModel.taxType = this.customerTax.value_json['tax_type'];
            console.log('Customer tax details applied', this.customerTax.value_json);
          } else if (pricingSchemeData?.output_tax_code && pricingSchemeData?.output_tax_code !== undefined && pricingSchemeData?.output_tax_code !== null && pricingSchemeData?.output_tax_code !== "") {
            pricingSchemeModel.taxCode = pricingSchemeData?.output_tax_code
            pricingSchemeModel.taxRate = pricingSchemeData?.output_tax_rate
            pricingSchemeModel.taxType = pricingSchemeData?.output_tax_type
            console.log("pricingSchemeData applied");
          } else if (this.fiItem && this.fiItem !== undefined && this.fiItem !== null && this.fiItem?.bl_fi_mst_item_hdr?.output_tax_code !== "") {
            pricingSchemeModel.taxCode = this.fiItem?.bl_fi_mst_item_hdr?.output_tax_code ? this.fiItem?.bl_fi_mst_item_hdr?.output_tax_code.toString() : null;
            pricingSchemeModel.taxRate = +this.fiItem?.bl_fi_mst_item_hdr?.output_tax_rate;
            pricingSchemeModel.taxType = this.fiItem?.bl_fi_mst_item_hdr?.output_tax_type ? this.fiItem?.bl_fi_mst_item_hdr?.output_tax_type.toString() : null;
          } else if (companyTax && companyTax !== undefined && companyTax !== null && companyTax?.taxCode && companyTax?.taxCode !== "") {
            pricingSchemeModel.taxCode = companyTax?.taxCode
            pricingSchemeModel.taxRate = companyTax?.taxRate
            pricingSchemeModel.taxType = companyTax?.taxType
          } else {
            pricingSchemeModel.taxCode = ""
            pricingSchemeModel.taxRate = 0
            pricingSchemeModel.taxType = ""
          }

          pricingSchemeModel.pricingSchemeAccessKey = pricingSchemeData.item_hdr_guid.concat(
            pricingSchemeData?.item_line_guid ? pricingSchemeData?.item_line_guid : ""
          );
          pricingSchemeModel.uom = pricingSchemeData?.uom;
          pricingSchemeModel.price_code = pricingSchemeData?.pricing_scheme_code;
          pricingSchemeModel.price_name = pricingSchemeData?.pricing_scheme_name;
          pricingSchemeModel.price_amount_incl_tax = pricingSchemeData?.sales_unit_price;
          pricingSchemeModel.price_amount_excl_tax = pricingSchemeData?.sales_unit_price_excl_tax;
          pricingSchemeModel.price_min = pricingSchemeData?.sales_min_price;
          pricingSchemeModel.price_max = pricingSchemeData?.sales_max_price;
          pricingSchemeModel.guid_pricing_scheme_hdr = pricingSchemeData?.guid_pricing_scheme_hdr;
          pricingSchemeModel.replacement_unit_price_excl_tax = pricingSchemeData?.replacement_unit_price_excl_tax;
          pricingSchemeModel.ref_price1_excl_tax = pricingSchemeData?.ref_price1_excl_tax;
          pricingSchemeModel.ref_price2_excl_tax = pricingSchemeData?.ref_price2_excl_tax;
          pricingSchemeModel.ref_price3_excl_tax = pricingSchemeData?.ref_price3_excl_tax;
          pricingSchemeModel.delta_price1_excl_tax = pricingSchemeData?.delta_price1_excl_tax;
          pricingSchemeModel.delta_price2_excl_tax = pricingSchemeData?.delta_price2_excl_tax;
          pricingSchemeModel.delta_price3_excl_tax = pricingSchemeData?.delta_price3_excl_tax;
          pricingSchemeModel.rebate_price1_excl_tax = pricingSchemeData?.rebate_price1_excl_tax;
          pricingSchemeModel.rebate_price2_excl_tax = pricingSchemeData?.rebate_price2_excl_tax;
          pricingSchemeModel.rebate_price3_excl_tax = pricingSchemeData?.rebate_price3_excl_tax;
          pricingSchemeModel.sales_min_price_excl_tax = pricingSchemeData?.sales_min_price_excl_tax;
          pricingSchemeModel.sales_max_price_excl_tax = pricingSchemeData?.sales_max_price_excl_tax;
          pricingSchemeModel.purchase_min_price_excl_tax = pricingSchemeData?.purchase_min_price_excl_tax;
          pricingSchemeModel.purchase_max_price_excl_tax = pricingSchemeData?.purchase_max_price_excl_tax;
          pricingSchemeModel.guid_pricing_scheme_link = pricingSchemeData?.guid;

          salesSidePricingSchemeList.push(pricingSchemeModel);
          salesSidePricingSchemeList = salesSidePricingSchemeList
            .reverse()
            .filter((item, index, self) =>
              index === self.findIndex((t) => t?.guid_pricing_scheme_hdr === item?.guid_pricing_scheme_hdr)
            )
            .reverse();
          console.log("salesSidePricingSchemeList", salesSidePricingSchemeList);
        };

        const applyDefaultPricingScheme = (defaultPricingSchemeModel) => {
          if (defaultPricingSchemeModel && this.canEmitPriceSelected(defaultPricingSchemeModel)) {
            this.onPriceSelected(defaultPricingSchemeModel);
            this.pricingScheme.patchValue(defaultPricingSchemeModel);
          }
        };

        const finalizePricingSchemes = () => {
          if (this.pricingSchemeAccessKey !== null) {
            this.filteredPricingSchemes = salesSidePricingSchemeList.filter(
              (pricingScheme) => pricingScheme.pricingSchemeAccessKey === this.pricingSchemeAccessKey
            );
          } else {
            this.filteredPricingSchemes = salesSidePricingSchemeList;
          }

          if (this.filteredPricingSchemes.length > 0 && this.validStatus()) {
            this.selectFieldDisabled = false;
          }

          const noPriceNames = this.filteredPricingSchemes.every(scheme => !scheme.price_name);

          if (noPriceNames) {
            this.selectFieldDisabled = true;
          }

          if (this.filteredPricingSchemes.length === 1) {
            applyDefaultPricingScheme(this.filteredPricingSchemes[0]);
          } else if (this.customerGuid) {
            this.customerService.getByGuid(this.customerGuid, AppConfig.apiVisa).subscribe(customer => {
              const customerPricingSchemeHdrGuid = customer.data.bl_fi_mst_entity_hdr.pricing_scheme_hdr_guid;
              const defaultPricingSchemeModel = this.filteredPricingSchemes.find(
                (l) => l.guid_pricing_scheme_hdr === customerPricingSchemeHdrGuid
              ) || this.filteredPricingSchemes.find(
                (l) => l.guid_pricing_scheme_hdr === this.defaultPricingSchemeHdr
              );

              applyDefaultPricingScheme(defaultPricingSchemeModel);
            });
          } else {
            const defaultPricingSchemeModel = this.filteredPricingSchemes.find(
              (l) => l.guid_pricing_scheme_hdr === this.defaultPricingSchemeHdr
            );

            applyDefaultPricingScheme(defaultPricingSchemeModel);
          }
        };

        if (this.entityBranch) {
          this.entityBranchHdr = this.entityBranch;

          if (data?.data?.length) {
            data.data.forEach((data) => processPricingScheme(data));
            finalizePricingSchemes();
          } else if (this.entityBranchHdr?.output_tax_code !== ""){
            const defaultPricingSchemeModel = new PricingSchemeModel();
            defaultPricingSchemeModel.taxCode = this.entityBranchHdr?.output_tax_code || "";
            defaultPricingSchemeModel.taxRate = this.entityBranchHdr?.output_tax_rate || 0;
            defaultPricingSchemeModel.taxType = this.entityBranchHdr?.output_tax_type || "";
            defaultPricingSchemeModel.pricingSchemeAccessKey = this.pricingSchemeAccessKey;

            salesSidePricingSchemeList.push(defaultPricingSchemeModel);
            finalizePricingSchemes();
          }
        } else {
          data.data.forEach(pricingSchemeData => {
            processPricingScheme(pricingSchemeData);
          });
          finalizePricingSchemes();
        }

        if (this.customerGuid) {
          this.customerService.getByGuid(this.customerGuid, this.apiVisa).subscribe(customer => {
            this.customerTax = customer.data.bl_fi_mst_entity_ext.find(element =>
              element.param_code === 'TAX_DETAILS' && element.status != 'DELETED');

            if (data?.data?.length) {
              data.data.forEach((data) => processPricingScheme(data));
              finalizePricingSchemes();
            } else if (this.customerTax?.value_json['tax_code'] !== "") {
              const defaultPricingSchemeModel = new PricingSchemeModel();
              defaultPricingSchemeModel.taxCode = this.customerTax?.value_json['tax_code'] || ""
              defaultPricingSchemeModel.taxRate = this.customerTax?.value_json['tax_rate'] || 0
              defaultPricingSchemeModel.taxType = this.customerTax?.value_json['tax_type'] || ""
              defaultPricingSchemeModel.pricingSchemeAccessKey = this.pricingSchemeAccessKey;

              salesSidePricingSchemeList.push(defaultPricingSchemeModel);
              finalizePricingSchemes();
            }
          });
        } else {
          data.data.forEach(pricingSchemeData => {
            processPricingScheme(pricingSchemeData);
          });
          finalizePricingSchemes();
        }

        if (this.companyGuid) {
          this.companyService.getByGuid(this.companyGuid, this.apiVisa).subscribe(response => {
            const company = response.data;
            console.log("Company Data: ", company);
            if (company.bl_fi_mst_comp?.default_tax_code_output) {
              this.taxConfigService.getByGuid(company.bl_fi_mst_comp.default_tax_code_output.toString(), this.apiVisa).subscribe(taxResponse => {
                if (taxResponse?.data) {
                  companyTax = {
                    taxCode: taxResponse.data.bl_fi_cfg_tax_code?.tax_code ? taxResponse.data.bl_fi_cfg_tax_code.tax_code.toString() : "",
                    taxRate: taxResponse.data.bl_fi_cfg_tax_code?.tax_rate_filing ? +taxResponse.data.bl_fi_cfg_tax_code.tax_rate_filing : 0,
                    taxType: taxResponse.data.bl_fi_cfg_tax_code?.tax_gst_type ? taxResponse.data.bl_fi_cfg_tax_code.tax_gst_type.toString() : "",
                  };
                  if (data?.data?.length) {
                    data.data.forEach((data) => processPricingScheme(data));
                    finalizePricingSchemes();
                  } else if(companyTax?.taxCode !== "") {
                    const defaultPricingSchemeModel = new PricingSchemeModel();
                    defaultPricingSchemeModel.taxCode = companyTax?.taxCode
                    defaultPricingSchemeModel.taxRate = companyTax?.taxRate
                    defaultPricingSchemeModel.taxType = companyTax?.taxType
                    defaultPricingSchemeModel.pricingSchemeAccessKey = this.pricingSchemeAccessKey;

                    salesSidePricingSchemeList.push(defaultPricingSchemeModel);
                    finalizePricingSchemes();
                  }
                }
              });
            }
          });
        } else {
          data.data.forEach(pricingSchemeData => {
            processPricingScheme(pricingSchemeData);
          });
          finalizePricingSchemes();
        }

        if (!data?.data?.length && this.fiItem?.bl_fi_mst_item_hdr?.output_tax_code !== "") {
          const defaultPricingSchemeModel = new PricingSchemeModel();
          defaultPricingSchemeModel.taxCode = this.fiItem?.bl_fi_mst_item_hdr?.output_tax_code || ""
          defaultPricingSchemeModel.taxRate = this.fiItem?.bl_fi_mst_item_hdr?.output_tax_rate || 0
          defaultPricingSchemeModel.taxType = this.fiItem?.bl_fi_mst_item_hdr?.output_tax_type || ""
          defaultPricingSchemeModel.pricingSchemeAccessKey = this.pricingSchemeAccessKey;

          salesSidePricingSchemeList.push(defaultPricingSchemeModel);
          finalizePricingSchemes();
        }
      });
  }
  
  validStatus(){
    const valid = !this.postingStatus  ||
                  (this.postingStatus  && this.postingStatus !== 'FINAL' && this.postingStatus !== 'VOID' && this.postingStatus !== 'DISCARDED');
    return valid;
  }

  canEmitPriceSelected(pricingScheme: PricingSchemeModel) {
    if (this.editMode && pricingScheme) {
      return false;
    } else {
      return true;
    }
  }

  getPurchaseSidePricingScheme() {
    let companyTax: CompanyTax;

    this.pricingSchemeLinkService
      .getPurchaseSidePricingSchemes(
        this.dtoObject,
        this.appletGuid,
        this.tenantGuid,
        this.rank,
        this.apiVisa
      )
      .subscribe((data) => {
        let purchaseSidePricingSchemeList: PricingSchemeModel[] = [];

        const processPricingScheme = (pricingSchemeData) => {
          let pricingSchemeModel = new PricingSchemeModel();
          console.log("1. entityBranchHdr", this.entityBranchHdr);
          console.log("2. supplierTax", this.supplierTax);
          console.log("3. pricingSchemeData", pricingSchemeData);
          console.log("4. fiItem", this.fiItem);
          console.log("5. companyTax", companyTax);
          if (this.entityBranchHdr && this.entityBranchHdr?.input_tax_code !== undefined && this.entityBranchHdr?.input_tax_code !== null && this.entityBranchHdr?.input_tax_code !== "") {
            pricingSchemeModel.taxCode = this.entityBranchHdr?.input_tax_code
            pricingSchemeModel.taxRate = this.entityBranchHdr?.input_tax_rate
            pricingSchemeModel.taxType = this.entityBranchHdr?.input_tax_type
          } else if (this.supplierTax && this.supplierTax !== undefined && this.supplierTax !== null && this.supplierTax?.value_json && this.supplierTax?.value_json['tax_code'] !== "") {
            pricingSchemeModel.taxCode = this.supplierTax?.value_json['tax_code']
            pricingSchemeModel.taxRate = this.supplierTax?.value_json['tax_rate']
            pricingSchemeModel.taxType = this.supplierTax?.value_json['tax_type']
          } else if (pricingSchemeData?.input_tax_code && pricingSchemeData?.input_tax_code !== undefined && pricingSchemeData?.input_tax_code !== null && pricingSchemeData?.input_tax_code !== "") {
            pricingSchemeModel.taxCode = pricingSchemeData?.input_tax_code
            pricingSchemeModel.taxRate = pricingSchemeData?.input_tax_rate
            pricingSchemeModel.taxType = pricingSchemeData?.input_tax_type
          } else if (this.fiItem && this.fiItem !== undefined && this.fiItem !== null && this.fiItem?.bl_fi_mst_item_hdr?.input_tax_code !== "") {
            pricingSchemeModel.taxCode = this.fiItem?.bl_fi_mst_item_hdr?.input_tax_code ? this.fiItem?.bl_fi_mst_item_hdr?.input_tax_code.toString() : null;
            pricingSchemeModel.taxRate = +this.fiItem?.bl_fi_mst_item_hdr?.input_tax_rate;
            pricingSchemeModel.taxType = this.fiItem?.bl_fi_mst_item_hdr?.input_tax_type ? this.fiItem?.bl_fi_mst_item_hdr?.input_tax_type.toString() : null;
          } else if (companyTax && companyTax !== undefined && companyTax !== null && companyTax?.taxCode && companyTax?.taxCode !== "") {
            pricingSchemeModel.taxCode = companyTax?.taxCode
            pricingSchemeModel.taxRate = companyTax?.taxRate
            pricingSchemeModel.taxType = companyTax?.taxType
          } else {
            pricingSchemeModel.taxCode = ""
            pricingSchemeModel.taxRate = 0
            pricingSchemeModel.taxType = ""
          }

          pricingSchemeModel.pricingSchemeAccessKey = pricingSchemeData.item_hdr_guid.concat(
            pricingSchemeData?.item_line_guid ? pricingSchemeData?.item_line_guid : ""
          );
          pricingSchemeModel.uom = pricingSchemeData?.uom;
          pricingSchemeModel.price_code = pricingSchemeData?.pricing_scheme_code;
          pricingSchemeModel.price_name = pricingSchemeData?.pricing_scheme_name;
          pricingSchemeModel.price_amount_incl_tax = pricingSchemeData?.purchase_unit_price;
          pricingSchemeModel.price_amount_excl_tax = pricingSchemeData?.purchase_unit_price_excl_tax;
          pricingSchemeModel.price_min = pricingSchemeData?.purchase_min_price;
          pricingSchemeModel.price_max = pricingSchemeData?.purchase_max_price;
          pricingSchemeModel.guid_pricing_scheme_hdr = pricingSchemeData?.guid_pricing_scheme_hdr;
          pricingSchemeModel.replacement_unit_price_excl_tax = pricingSchemeData?.replacement_unit_price_excl_tax;
          pricingSchemeModel.ref_price1_excl_tax = pricingSchemeData?.ref_price1_excl_tax;
          pricingSchemeModel.ref_price2_excl_tax = pricingSchemeData?.ref_price2_excl_tax;
          pricingSchemeModel.ref_price3_excl_tax = pricingSchemeData?.ref_price3_excl_tax;
          pricingSchemeModel.delta_price1_excl_tax = pricingSchemeData?.delta_price1_excl_tax;
          pricingSchemeModel.delta_price2_excl_tax = pricingSchemeData?.delta_price2_excl_tax;
          pricingSchemeModel.delta_price3_excl_tax = pricingSchemeData?.delta_price3_excl_tax;
          pricingSchemeModel.rebate_price1_excl_tax = pricingSchemeData?.rebate_price1_excl_tax;
          pricingSchemeModel.rebate_price2_excl_tax = pricingSchemeData?.rebate_price2_excl_tax;
          pricingSchemeModel.rebate_price3_excl_tax = pricingSchemeData?.rebate_price3_excl_tax;
          pricingSchemeModel.sales_min_price_excl_tax = pricingSchemeData?.sales_min_price_excl_tax;
          pricingSchemeModel.sales_max_price_excl_tax = pricingSchemeData?.sales_max_price_excl_tax;
          pricingSchemeModel.purchase_min_price_excl_tax = pricingSchemeData?.purchase_min_price_excl_tax;
          pricingSchemeModel.purchase_max_price_excl_tax = pricingSchemeData?.purchase_max_price_excl_tax;
          pricingSchemeModel.guid_pricing_scheme_link = pricingSchemeData?.guid;
          pricingSchemeModel.purchase_selling_list_price_incl_tax = pricingSchemeData?.purchase_selling_list_price_incl_tax;

          purchaseSidePricingSchemeList.push(pricingSchemeModel);
          purchaseSidePricingSchemeList = purchaseSidePricingSchemeList
          .reverse()
          .filter((item, index, self) =>
            index === self.findIndex((t) => t?.guid_pricing_scheme_hdr === item?.guid_pricing_scheme_hdr)
          )
          .reverse();
          console.log("purchaseSidePricingSchemeList", purchaseSidePricingSchemeList);
        };

        const applyDefaultPricingScheme = (defaultPricingSchemeModel) => {
          if (defaultPricingSchemeModel && this.canEmitPriceSelected(defaultPricingSchemeModel)) {
            this.onPriceSelected(defaultPricingSchemeModel);
            this.pricingScheme.patchValue(defaultPricingSchemeModel);
          }
        };

        const finalizePricingSchemes = () => {
          if (this.pricingSchemeAccessKey !== null) {
            this.filteredPricingSchemes = purchaseSidePricingSchemeList.filter(
              (pricingScheme) => pricingScheme.pricingSchemeAccessKey === this.pricingSchemeAccessKey
            );
          } else {
            this.filteredPricingSchemes = purchaseSidePricingSchemeList;
          }

          if (this.filteredPricingSchemes.length > 0 && this.validStatus()) {
            this.selectFieldDisabled = false;
          }

          const noPriceNames = this.filteredPricingSchemes.every(scheme => !scheme.price_name);

          if (noPriceNames) {
            this.selectFieldDisabled = true;
          }

          if (this.filteredPricingSchemes.length === 1) {
            applyDefaultPricingScheme(this.filteredPricingSchemes[0]);
          } else if (this.supplierGuid) {
            this.supplierService.getByGuid(this.supplierGuid, AppConfig.apiVisa).subscribe(customer => {
              const supplierPricingSchemeHdrGuid = customer.data.bl_fi_mst_entity_hdr.pricing_scheme_hdr_guid;
              const defaultPricingSchemeModel = this.filteredPricingSchemes.find(
                (l) => l.guid_pricing_scheme_hdr === supplierPricingSchemeHdrGuid
              ) || this.filteredPricingSchemes.find(
                (l) => l.guid_pricing_scheme_hdr === this.defaultPricingSchemeHdr
              );

              applyDefaultPricingScheme(defaultPricingSchemeModel);
            });
          } else {
            const defaultPricingSchemeModel = this.filteredPricingSchemes.find(
              (l) => l.guid_pricing_scheme_hdr === this.defaultPricingSchemeHdr
            );

            applyDefaultPricingScheme(defaultPricingSchemeModel);
          }
        };

        if (this.entityBranch) {
          this.entityBranchHdr = this.entityBranch;

          if (data?.data?.length) {
            data.data.forEach((data) => processPricingScheme(data));
            finalizePricingSchemes();
          } else if (this.entityBranchHdr?.input_tax_code !== null) {
            const defaultPricingSchemeModel = new PricingSchemeModel();
            defaultPricingSchemeModel.taxCode = this.entityBranchHdr?.input_tax_code || "";
            defaultPricingSchemeModel.taxRate = this.entityBranchHdr?.input_tax_rate || 0;
            defaultPricingSchemeModel.taxType = this.entityBranchHdr?.input_tax_type || "";
            defaultPricingSchemeModel.pricingSchemeAccessKey = this.pricingSchemeAccessKey;

            purchaseSidePricingSchemeList.push(defaultPricingSchemeModel);
            finalizePricingSchemes();
          }
        } else {
          data.data.forEach((data) => processPricingScheme(data));
          finalizePricingSchemes();
        }

        if (this.supplierGuid) {
          this.supplierService.getByGuid(this.supplierGuid, this.apiVisa).subscribe(supplier => {
            this.supplierTax = supplier.data.bl_fi_mst_entity_ext.find(element =>
              element.param_code === 'TAX_DETAILS' && element.status != 'DELETED');

            if (data?.data?.length) {
              data.data.forEach((data) => processPricingScheme(data));
              finalizePricingSchemes();
            } else if(this.supplierTax?.value_json['tax_code'] !== null) {
              const defaultPricingSchemeModel = new PricingSchemeModel();
              defaultPricingSchemeModel.taxCode = this.supplierTax?.value_json['tax_code'] || ""
              defaultPricingSchemeModel.taxRate = this.supplierTax?.value_json['tax_rate'] || 0
              defaultPricingSchemeModel.taxType = this.supplierTax?.value_json['tax_type'] || ""
              defaultPricingSchemeModel.pricingSchemeAccessKey = this.pricingSchemeAccessKey;

              purchaseSidePricingSchemeList.push(defaultPricingSchemeModel);
              finalizePricingSchemes();
            }
          });
        } else {
          data.data.forEach(pricingSchemeData => {
            processPricingScheme(pricingSchemeData);
          });
          finalizePricingSchemes();
        }

        if (this.companyGuid) {
          this.companyService.getByGuid(this.companyGuid, this.apiVisa).subscribe(response => {
            const company = response.data;
            console.log("Company Data: ", company);

            if (company.bl_fi_mst_comp?.default_tax_code_input) {
              this.taxConfigService.getByGuid(company.bl_fi_mst_comp.default_tax_code_input.toString(), this.apiVisa).subscribe(taxResponse => {
                if (taxResponse?.data) {
                  companyTax = {
                    taxCode: taxResponse.data.bl_fi_cfg_tax_code?.tax_code ? taxResponse.data.bl_fi_cfg_tax_code.tax_code.toString() : "",
                    taxRate: taxResponse.data.bl_fi_cfg_tax_code?.tax_rate_filing ? +taxResponse.data.bl_fi_cfg_tax_code.tax_rate_filing : 0,
                    taxType: taxResponse.data.bl_fi_cfg_tax_code?.tax_gst_type ? taxResponse.data.bl_fi_cfg_tax_code.tax_gst_type.toString() : "",
                  };

                  console.log("companyTax", companyTax);
                  if (data?.data?.length) {
                    data.data.forEach((data) => processPricingScheme(data));
                    finalizePricingSchemes();
                  } else if(companyTax?.taxCode !== "") {
                    const defaultPricingSchemeModel = new PricingSchemeModel();
                    defaultPricingSchemeModel.taxCode = companyTax?.taxCode
                    defaultPricingSchemeModel.taxRate = companyTax?.taxRate
                    defaultPricingSchemeModel.taxType = companyTax?.taxType
                    defaultPricingSchemeModel.pricingSchemeAccessKey = this.pricingSchemeAccessKey;

                    purchaseSidePricingSchemeList.push(defaultPricingSchemeModel);
                    finalizePricingSchemes();
                  }
                }
              });
            }
          });
        } else {
          data.data.forEach(pricingSchemeData => {
            processPricingScheme(pricingSchemeData);
          });
          finalizePricingSchemes();
        }

        if (!data?.data?.length && this.fiItem?.bl_fi_mst_item_hdr?.input_tax_code !== "") {
          const defaultPricingSchemeModel = new PricingSchemeModel();
          defaultPricingSchemeModel.taxCode = this.fiItem?.bl_fi_mst_item_hdr?.input_tax_code || ""
          defaultPricingSchemeModel.taxRate = this.fiItem?.bl_fi_mst_item_hdr?.input_tax_rate || 0
          defaultPricingSchemeModel.taxType = this.fiItem?.bl_fi_mst_item_hdr?.input_tax_type || ""
          defaultPricingSchemeModel.pricingSchemeAccessKey = this.pricingSchemeAccessKey;

          purchaseSidePricingSchemeList.push(defaultPricingSchemeModel);
          finalizePricingSchemes();
        }
      });
  }  

  onPriceSelected(e: any) {
    console.log("Price Selected Event", e);
  
    const { taxCode, taxRate, taxType, pricingSchemeAccessKey, ...rest } = e;
  
    const hasOnlyTaxProperties = 
      Object.keys(rest).length === 0 && 
      taxRate && 
      taxType && pricingSchemeAccessKey;
  
    if ((hasOnlyTaxProperties && taxCode !== "") || Object.keys(rest).length > 0) {
      this.selectedPricingScheme.emit(e);
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
